<template>
  <div class="DealDetails">
    <el-tabs v-model="activeName">
      <el-tab-pane
        :label="$t('dealDetailsTabBill')"
        name="bill"
      >
        <DealBillTable :deal="deal" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue';
import { Tabs, TabPane } from 'element-ui';
// Components
import DealBillTable from '@/components/deal/BillTable.vue';

Vue.use(Tabs);
Vue.use(TabPane);

export default {
  name: 'DealDetails',
  components: {
    DealBillTable,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeName: 'bill',
    };
  },
};
</script>
